import * as Sentry from '@sentry/vue'

export const SentryService = {
  logError(error: unknown, context?: Record<string, unknown>) {
    Sentry.captureException(error, { extra: context })
  },

  captureException(error: unknown, context?: Record<string, unknown>) {
    this.logError(error, context)
  },

  logMessage(message: string, level: Sentry.SeverityLevel = 'info') {
    Sentry.captureMessage(message, level)
  },

  setUser(id: string, email?: string) {
    Sentry.setUser({ id, email })
  },

  clearUser() {
    Sentry.setUser(null)
  },

  setTag(key: string, value: string) {
    Sentry.setTag(key, value)
  },
}
